import React, { useEffect } from 'react';
import { CheckboxInput, useFormContextRequired } from 'ui-builder';
import { RoadmapCheckboxesToggleWrapper } from 'feature-toggle';

export function PortalRoadmapCheckbox() {

  const formContext = useFormContextRequired<{ isPrivate: boolean }>();

  useEffect(() => {

    if (formContext.data?.isPrivate) {
      formContext.onChangeCallback({
        isIncludedToRoadmap: false,
      })
    }
  }, [formContext.data?.isPrivate]);

  return (
    <RoadmapCheckboxesToggleWrapper>
      <CheckboxInput
        source="isIncludedToRoadmap"
        label="Portal Roadmap"
        isDisabled={(data) => data.isPrivate}
      />
    </RoadmapCheckboxesToggleWrapper>
  );
}
